import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { Subscription } from 'rxjs';
import { mergeMapTo } from 'rxjs/operators';
import { DialogSemConexao } from './components/dialogs/dialogs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NetworkStatusService } from './services/network-status.service';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'martech-app-vendedor';
  semConexao = false;
  verificandoConexao = false;
  semConexaoAposVerificar = false;
  private networkSub!: Subscription;
  private dialogSemConexaoRef: MatDialogRef<DialogSemConexao> | null = null;

  constructor(
    private afs: AngularFirestore,
    private afMessaging: AngularFireMessaging,
    private fireAuth: AngularFireAuth,
    private dialog: MatDialog,
    private networkService: NetworkStatusService,
  ) {

    this.forceSWupdate();


  }

  ngOnInit(): void {
    this.networkSub = this.networkService.online$.subscribe((online) => {
      if (!online) {
        this.semConexao = true;
        this.semConexaoAposVerificar = false;
      }
    });
  }

  async verificarConexao(): Promise<void> {
    this.verificandoConexao = true;
    this.semConexaoAposVerificar = false;

    const conectado = await this.networkService.checkConnection();

    this.verificandoConexao = false;

    if (conectado) {
      this.semConexao = false;
    } else {
      this.semConexaoAposVerificar = true;
    }
  }

  private fecharDialogSemConexao(): void {
    if (this.dialogSemConexaoRef) {
      this.dialogSemConexaoRef.close(true);
      this.dialogSemConexaoRef = null;
    }
  }

  requestPermission() {
    this.afMessaging.requestPermission
      .pipe(mergeMapTo(this.afMessaging.tokenChanges))
      .subscribe(
        (token) => {
          console.log('Permission granted! Save to the server!', token);
          this.afs.collection('fcmtokens').add({ token });
        },
        (error) => { console.error(error); },
      );
  }


  forceSWupdate() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          console.log(registration);
          registration.update()
        }
      })
    }
  }

  ngOnDestroy(): void {
    this.networkSub?.unsubscribe();
  }
}
